<p>equilibria works!</p>
